import React from 'react';
import PlaceSelectContainer from '../../../shared/containers/place_select/PlaceSelectContainer';

const LodgingSelect = ({ id, onChange, step = null, route = null, className, placeholder, input, onBlur, onFocus, ...others }) =>
    <PlaceSelectContainer
        id={id}
        filters={{
            type: 'stop',
            step: step,
            route: route,
            purpose: 'lodging'
        }}
        onChange={(stop)=>{
            onChange(stop);
            input.onChange(stop)
        }}
        value={input.value}
        placeholder={placeholder}
        autoload={true}
        noOptionsMessage={() =>"Pas de résultats"}
        loadingMessage={()=>"Recherche en cours..."}
        onBlur={(e)=>{
            onBlur && onBlur(e)
            input.onBlur(e)
        }}
        onFocus={(e)=>{
            onFocus && onFocus(e)
            input.onBlur(e)
        }}
        {...others}
    />
;

export default LodgingSelect;
